/*  eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */

import React, { useEffect } from "react";
import Chip from "@material-ui/core/Chip";
import Dialog from "@material-ui/core/Dialog";
import { connect } from "react-redux";
import { withRouter } from "../../Utility/withRouter";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { addAttribute } from "../../Actions/Form";
import * as validator from "../../Utility/validations";
import SelectMedia from "./SelectMedia";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import CircularProgress from "@material-ui/core/CircularProgress";
import {
    useGetAPICallQuery,
    useMutationAPICallMutation,
} from "../../app/services/account";
import SelectContact from "./SelectContact";
import update from "immutability-helper";
import {
    validateField,
    responseHandler,
    sortAscending,
    sortContactAscending,
} from "../../Utility/Utility";
import SelectTags from "./SelectTags";
import moment from "moment";
import LegacyAttachments from "./LegacyAttachments";

const AddLegacy = (props) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [updateLegacy, { isLoading }] = useMutationAPICallMutation();
    const contactList = useGetAPICallQuery("contact");
    const mediaList = useGetAPICallQuery("media");
    const [contactData, setcontactData] = React.useState({
        contacts: {
            value: [],
            // validations: { required: true },
            valid: true,
        },
        messageContentType: {
            value: [],
            // validations: { required: true },
            options: [],
            valid: true,
        },
        attachments: {
            value: [],
            // validations: { required: true },
            valid: true,
        },
        name: {
            value: "",
            validations: { required: true },
            valid: false,
            text: "LEGACY_DESC_TITLE",
        },
        content: {
            value: "",
            // validations: { required: true },
            valid: true,
            text: "PERSONAL_MESSAGE",
        },
    });

    React.useEffect(() => {
        if (!props.form.openFutureMedia && !props.form.openFutureContact  && contactList.data && mediaList.data) {
            let oldMedia = mediaList.data?.mediaList;
            let oldContact = contactList.data?.contactList;
            if (props.form.accountData.mediaList) {
                props.form.accountData.mediaList.map((item) => {
                    mediaList.data.mediaList.map((media, index) => {
                        if (
                            parseInt(item.system.id) ===
                                parseInt(media.system.id) &&
                            item.checked
                        ) {
                            oldMedia = update(oldMedia, {
                                [index]: {
                                    $set: { ...media, checked: true },
                                },
                            });
                        }
                    });
                });
            }

            if (props.form.accountData.contactList) {
                props.form.accountData.contactList.map((item) => {
                    contactList.data.contactList.map((contact, index) => {
                        if (
                            parseInt(item.system.id) ===
                                parseInt(contact.system.id) &&
                            item.checked
                        ) {
                            oldContact = update(oldContact, {
                                [index]: {
                                    $set: {
                                        ...contact,
                                        checked: true,
                                    },
                                },
                            });
                        }
                    });
                });
            }

            if (props.form.selectedLegacy) {
                let tags = [];
                let options = contactData.messageContentType.options;
                let tagsSplit = props.form.selectedLegacy.meta.tags.split(";");
                if (tagsSplit.length > 0) {
                    tagsSplit.map((tag) => {
                        if (tag) {
                            let filter =
                                contactData.messageContentType.options.filter(
                                    (item) => item.value === tag
                                )[0];
                            if (!filter) {
                                options.push({
                                    label: tag,
                                    value: tag,
                                });
                            }
                            tags.push(tag);
                        }
                    });
                }
                if (props.form.accountData.legacyTags) {
                    props.form.accountData.legacyTags.map((item) => {
                        let filteredTag = options.filter(
                            (opt) => item === opt.value
                        )[0];
                        if (!filteredTag && item) {
                            options.push({
                                label: item,
                                value: item,
                            });
                        }
                    });
                }

                setcontactData({
                    ...contactData,
                    messageContentType: {
                        ...contactData.messageContentType,
                        options: options,
                        value: tags,
                    },
                    name: {
                        ...contactData.name,
                        value: props.form.selectedLegacy.data.title,
                    },
                    content: {
                        ...contactData.content,
                        value: props.form.selectedLegacy.data.message,
                    },
                });

                let split = props.form.selectedLegacy.data.mediaID.split(";");
                if (split.length > 0) {
                    split.map((item) => {
                        if (item) {
                            mediaList.data.mediaList.map((media, index) => {
                                if (
                                    parseInt(item) === parseInt(media.system.id)
                                ) {
                                    oldMedia = update(oldMedia, {
                                        [index]: {
                                            $set: { ...media, checked: true },
                                        },
                                    });
                                }
                            });
                        }
                    });
                }

                let contactSplit =
                    props.form.selectedLegacy.data.contactID.split(";");
                if (contactSplit.length > 0) {
                    contactSplit.map((item) => {
                        if (item) {
                            contactList.data.contactList.map(
                                (contact, index) => {
                                    if (
                                        parseInt(item) ===
                                        parseInt(contact.system.id)
                                    ) {
                                        oldContact = update(oldContact, {
                                            [index]: {
                                                $set: {
                                                    ...contact,
                                                    checked: true,
                                                },
                                            },
                                        });
                                    }
                                }
                            );
                        }
                    });
                }
            } else {
                if (props.form.accountData.legacyTags) {
                    let options = contactData.messageContentType.options;
                    props.form.accountData.legacyTags.map((item) => {
                        let filteredTag = options.filter(
                            (opt) => item === opt.value
                        )[0];
                        if (!filteredTag && item) {
                            options.push({
                                label: item,
                                value: item,
                            });
                        }
                    });
                    setcontactData({
                        ...contactData,
                        messageContentType: {
                            ...contactData.messageContentType,
                            options: options,
                        },
                    });
                }
            }
            props.addAttribute({
                name: "accountData",
                value: {
                    ...props.form.accountData,
                    mediaList: sortAscending(oldMedia),
                    contactList: sortContactAscending(oldContact),
                },
            });
        }
    }, [
        props.form.selectedLegacy ||
            props.contact ||
            mediaList.data ||
            contactList.data,
    ]);

    const hidefutureFormPopup = () => {
        props.addAttribute({
            name: "addLegacyFormPopup",
            value: false,
        });
        props.addAttribute({
            name: "editFutureLegacy",
            value: {},
        });
        props.addAttribute({
            name: "openFutureTags",
            value: false,
        });

        props.addAttribute({
            name: "openFutureContact",
            value: false,
        });

        props.addAttribute({
            name: "openFutureMedia",
            value: false,
        });

        let oldMedia = mediaList.data?.mediaList;
        let oldContact = contactList.data?.contactList;
        if (props.form.accountData.mediaList) {
            props.form.accountData.mediaList.map((item, index) => {
                oldMedia = update(oldMedia, {
                    [index]: {
                        $set: { ...item, checked: false },
                    },
                });
            });
        }

        if (props.form.accountData.contactList) {
            props.form.accountData.contactList.map((item, index) => {
                oldContact = update(oldContact, {
                    [index]: {
                        $set: {
                            ...item,
                            checked: false,
                        },
                    },
                });
            });
        }
        props.addAttribute({
            name: "accountData",
            value: {
                ...props.form.accountData,
                mediaList: sortAscending(oldMedia),
                contactList: sortContactAscending(oldContact),
            },
        });

        props.addAttribute({
            name: "selectedLegacy",
            value: null,
        });
    };

    const setTags = () => {
        if (props.form.accountData.legacyTags) {
            let options = contactData.messageContentType.options;
            props.form.accountData.legacyTags.map((item) => {
                let filteredTag = options.filter(
                    (opt) => item === opt.value
                )[0];
                if (!filteredTag && item) {
                    options.push({
                        label: item,
                        value: item,
                    });
                }
            });
            return {
                ...contactData.messageContentType,
                options: options,
            };
        } else {
            return contactData.messageContentType;
        }
    };

    const changeHandler = async (event) => {
        let newData = JSON.parse(JSON.stringify(contactData));
        if (event.currentTarget.name === "Agreement") {
            newData[event.currentTarget.name].value =
                event.currentTarget.checked;
        } else if (event.currentTarget.name === "Country") {
            newData[event.currentTarget.name].value = event;
        } else if (newData[event.currentTarget.name]) {
            newData[event.currentTarget.name].value = event.currentTarget.value;
        }

        //let validation = await validateField(newData, props.form.language);
        setcontactData(newData);
    };

    async function submit(newData, action) {
        let isFormValid = await validateField(newData, props.form.language);
        setcontactData(isFormValid.formatData);
        let isValid = true;
        Object.keys(contactData).map((data) => {
            if (contactData[data].valid === false) {
                isValid = false;
            }
        });
        if (isValid) {
            let selectedMediaList = props.form.accountData.mediaList.filter(
                (data) => data.checked === true
            );
            let mediaListID = ";";
            if (selectedMediaList.length > 0) {
                selectedMediaList.map((media) => {
                    mediaListID = mediaListID + media.system.id + ";";
                });
            }

            let selectedContactList = props.form.accountData.contactList.filter(
                (data) => data.checked === true
            );
            let contactListID = ";";
            if (selectedContactList.length > 0) {
                selectedContactList.map((contact) => {
                    contactListID = contactListID + contact.system.id + ";";
                });
            }

            let requestData = {
                url: props.form.selectedLegacy?.system?.id
                    ? `legacy/${props.form.selectedLegacy.system.id}`
                    : "legacy",
                method:
                    props.form.selectedLegacy &&
                    props.form.selectedLegacy?.system?.id
                        ? "PUT"
                        : "POST",
                meta: {
                    tags: contactData.messageContentType.value.join(";") + ";",
                    additionalInfo: "additional info",
                },
                data: {
                    title: contactData.name.value,
                    message: contactData.content.value,
                    mediaID: mediaListID,
                    contactID: contactListID,
                },
            };
            await updateLegacy(requestData)
                .unwrap()
                .then(async (response) => {
                    if (props.legacyListQuery) {
                        props.legacyListQuery.refetch();
                    }
                    await hidefutureFormPopup();
                });
        } else {
            alert(isFormValid.validationMsg);
        }
    }

    const handleDelete = (chipToDelete, type) => () => {
        let media = props.form.accountData.mediaList;
        let contact = props.form.accountData.contactList;
        if (type === "media" && media) {
            props.form.accountData.mediaList.map((item, index) => {
                if (
                    parseInt(item.system.id) ===
                    parseInt(chipToDelete.system.id)
                ) {
                    media = update(media, {
                        [index]: { $set: { ...item, checked: false } },
                    });
                }
            });
        } else if (contact) {
            props.form.accountData.contactList.map((item, index) => {
                if (
                    parseInt(item.system.id) ===
                    parseInt(chipToDelete.system.id)
                ) {
                    contact = update(contact, {
                        [index]: { $set: { ...item, checked: false } },
                    });
                }
            });
        }
        props.addAttribute({
            name: "accountData",
            value: {
                ...props.form.accountData,
                mediaList: sortAscending(media),
                contactList: sortContactAscending(contact),
            },
        });
    };

    const getName = (name) => {
        switch (name) {
            case "emergency":
                return props.form.language.CONTACT_TYPE_EMERGENCY;
            case "private":
                return props.form.language.CONTACT_TYPE_PRIVATE;
            case "family":
                return props.form.language.CONTACT_TYPE_FAMILY;
            case "healthcare":
                return props.form.language.CONTACT_TYPE_HEALTHCARE;
            case "financial":
                return props.form.language.CONTACT_TYPE_FINANCIAL;
            case "friend":
                return props.form.language.CONTACT_TYPE_FRIEND;
            case "other":
                return props.form.language.TYPE_OTHER;

            default:
                break;
        }
    };

    const openFutureMedia = (prop) => {
        props.addAttribute({
            name: "openFutureMedia",
            value: props.form.openFutureMedia ? false : true,
        });
    };

    const openFutureContact = (prop) => {
        props.addAttribute({
            name: "openFutureContact",
            value: props.form.openFutureContact ? false : true,
        });
    };

    const openFutureTags = (prop) => {
        props.addAttribute({
            name: "openFutureTags",
            value: props.form.openFutureTags ? false : true,
        });
    };

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <React.Fragment>
            {(props.form.isLoading ||
                isLoading ||
                contactList.isLoading ||
                mediaList.isLoading) && (
                <div className="overlay-momentio">
                    <CircularProgress
                        style={{ width: "100px", height: "100px" }}
                    />
                </div>
            )}
            <Dialog
                open={props.form.addLegacyFormPopup}
                fullScreen={fullScreen}
                onClose={hidefutureFormPopup}
                aria-labelledby="responsive-dialog-title"
                disableEscapeKeyDown={true}
            >
                {!props.form.openFutureContact &&
                    !props.form.openFutureMedia &&
                    !props.form.openFutureTags && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                position: "relative",
                            }}
                        >
                            <div
                                className="mm-form-container"
                            >
                                <div
                                    className="mm-login-container"
                                    style={{
                                        boxShadow: "none",
                                        paddingTop: "10px",
                                    }}
                                >
                                    <div
                                        style={{
                                            font: "normal normal 600 18px/64px Raleway",
                                            letterSpacing: "1.8px",
                                            color: "#23315580",
                                        }}
                                    >
                                        {`${
                                            props.form.language.QUESTION_LABEL
                                        } ${parseInt(value) + 1} ${
                                            props.form.language
                                                .QUESTION_LABEL_OF
                                        } 2`}
                                    </div>
                                    <Tabs
                                        style={{
                                            height: "16px",
                                            minHeight: "unset",
                                        }}
                                        value={value}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        onChange={handleChange}
                                    >
                                        <Tab
                                            style={{
                                                height: "16px",
                                                minHeight: "unset",
                                                borderRadius: "8px 0px 0px 8px",
                                                background:
                                                    "#6BCE90 0% 0% no-repeat padding-box",
                                                width: "49%",
                                                minWidth: "unset",
                                            }}
                                            label=""
                                        />
                                        <Tab
                                            style={{
                                                height: "16px",
                                                minHeight: "unset",
                                                borderRadius: "0",
                                                opacity:
                                                    value === 1 || value === 2
                                                        ? 1
                                                        : 0.1,
                                                background:
                                                    value === 1 || value === 2
                                                        ? "#6BCE90 0% 0% no-repeat padding-box"
                                                        : "#233155 0% 0% no-repeat padding-box",

                                                marginLeft: "4PX",
                                                width: "49%",
                                                minWidth: "unset",
                                            }}
                                            label=""
                                        />
                                    </Tabs>
                                    {value === 0 && (
                                        <div>
                                            <div
                                                className="mm-login-header"
                                                style={{ paddingTop: "20px" }}
                                            >
                                                {
                                                    props.form.language
                                                        .SEND_LEGACY
                                                }
                                            </div>
                                            <div className="login-field-label login-field-label-height">
                                                {
                                                    `${props.form.language
                                                        .LEGACY_DESC_TITLE}`
                                                }
                                            </div>
                                            <div className="login-field-input">
                                                <input
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder={
                                                        props.form.language
                                                            .FUTURE_MESSAGE_S7
                                                    }
                                                    name="name"
                                                    value={
                                                        contactData.name.value
                                                    }
                                                    onChange={changeHandler}
                                                />
                                            </div>
                                            <LegacyAttachments
                                                value={value}
                                                openFutureContact={
                                                    openFutureContact
                                                }
                                                openFutureMedia={
                                                    openFutureMedia
                                                }
                                                openFutureTags={openFutureTags}
                                                handleDelete={(value, type) =>
                                                    handleDelete(value, type)
                                                }
                                                tags={setTags()}
                                                updateTagList={(tag) => {
                                                    setcontactData({
                                                        ...contactData,
                                                        messageContentType: tag,
                                                    });
                                                }}
                                            />
                                        </div>
                                    )}
                                    {value === 1 && (
                                        <>
                                            <LegacyAttachments
                                                value={value}
                                                openFutureContact={
                                                    openFutureContact
                                                }
                                                openFutureMedia={
                                                    openFutureMedia
                                                }
                                                openFutureTags={openFutureTags}
                                                handleDelete={(value, type) =>
                                                    handleDelete(value, type)
                                                }
                                                tags={setTags()}
                                                updateTagList={(tag) => {
                                                    setcontactData({
                                                        ...contactData,
                                                        messageContentType: tag,
                                                    });
                                                }}
                                            />
                                            <div className="login-field-label login-field-label-height">
                                                {
                                                    props.form.language
                                                        .PERSONAL_MESSAGE
                                                }
                                            </div>
                                            <div className="login-field-input">
                                                <textarea
                                                    style={{ height: "auto" }}
                                                    rows="8"
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder={
                                                        props.form.language
                                                            .FUTURE_MESSAGE_S9
                                                    }
                                                    name="content"
                                                    value={
                                                        contactData.content
                                                            .value
                                                    }
                                                    onChange={changeHandler}
                                                />
                                            </div>
                                        </>
                                    )}
                                    <div
                                        className="mm-input-submit"
                                        style={{ display: "flex" }}
                                    >
                                        {value !== 1 && (
                                            <button
                                                style={{
                                                    textAlign: "center",
                                                    width: "360px",
                                                    marginTop: "24px",
                                                }}
                                                className="primary-button-blue"
                                                onClick={async () => {
                                                    let isFormValid =
                                                        await validateField(
                                                            contactData,
                                                            props.form.language
                                                        );
                                                    setcontactData(
                                                        isFormValid.formatData
                                                    );

                                                    let isValid = true;
                                                    Object.keys(
                                                        contactData
                                                    ).map((data) => {
                                                        if (
                                                            !contactData[data]
                                                                .hidden &&
                                                            contactData[data]
                                                                .valid === false
                                                        ) {
                                                            isValid = false;
                                                        }
                                                    });
                                                    if (isValid) {
                                                        setValue(
                                                            (prev) => prev + 1
                                                        );
                                                    } else {
                                                        alert(
                                                            isFormValid.validationMsg
                                                        );
                                                    }
                                                }}
                                            >
                                                {`${
                                                    props.form.language
                                                        .MESSAGE_STEP
                                                } ${parseInt(value) + 2}`}
                                            </button>
                                        )}

                                        {value === 1 && (
                                            <button
                                                style={{
                                                    textAlign: "center",
                                                    width: "360px",
                                                    marginTop: "24px",
                                                }}
                                                className="primary-button-blue"
                                                onClick={() => {
                                                    let contactsChecked =
                                                        props.form.accountData.contactList.filter(
                                                            (data) =>
                                                                data.checked ===
                                                                true
                                                        );
                                                    if (
                                                        contactsChecked.length >
                                                            0 &&
                                                        contactData.content
                                                            .value
                                                    ) {
                                                        submit(
                                                            contactData,
                                                            "insert"
                                                        );
                                                    } else {
                                                        let message = "";
                                                        if (
                                                            contactsChecked.length <
                                                            1
                                                        ) {
                                                            message =
                                                                message +
                                                                "\n" +
                                                                props.form.language.LEGACY_FOR +
                                                                " " +
                                                                props.form.language.MANDATORY_FIELD;
                                                        }
                                                        if (
                                                            !contactData.content
                                                            .value
                                                        ) {
                                                            message =
                                                                message +
                                                                "\n" +
                                                                props.form.language.PERSONAL_MESSAGE +
                                                                " " +
                                                                props.form.language.MANDATORY_FIELD;
                                                        }

                                                        alert(
                                                            message
                                                        );
                                                    }
                                                }}
                                            >
                                                {
                                                    props.form.language
                                                        .SAVE_MESSAGE
                                                }
                                            </button>
                                        )}
                                        <button
                                            style={{
                                                textAlign: "center",
                                                width: "250px",
                                                marginTop: "24px",
                                                marginLeft: "15px",
                                            }}
                                            className="secondary-button"
                                            onClick={hidefutureFormPopup}
                                        >
                                            {props.form.language.CANCEL}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                {!props.form.openFutureContact &&
                    props.form.openFutureMedia && (
                        <SelectMedia openFutureMedia={openFutureMedia} />
                    )}
                {props.form.openFutureContact &&
                    !props.form.openFutureMedia && (
                        <SelectContact
                            data={props.form.accountData.contactList}
                            openFutureContact={() => openFutureContact()}
                        />
                    )}
                {props.form.openFutureTags && (
                    <SelectTags
                        tags={contactData.messageContentType.options}
                        selectedTags={contactData.messageContentType}
                        openFutureTags={() => openFutureTags()}
                        updateTagList={(tags) => {
                            setcontactData({
                                ...contactData,
                                messageContentType: tags,
                            });
                        }}
                    />
                )}
            </Dialog>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return { ...state };
};
const mapDispatchToProps = (dispatch) => {
    return {
        addAttribute: (payload) => dispatch(addAttribute(payload)),
    };
};
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddLegacy)
);
